interface ReCaptchaBase {
  ready: (cb: () => void) => void
  render: (id: string, options: ReCaptchaRenderOptions) => void
  reset(opt_widget_id?: string): void
  getResponse(opt_widget_id?: string): string
}

interface ReCaptchaRenderOptions {
  sitekey: string
  size?: 'invisible' | 'compact' | 'normal'
  callback: 'captchaSuccess' | 'buttonCaptchaSuccess'
  'error-callback'?: 'buttonCaptchaError'
}

interface ReCaptchaInstanceV3 extends ReCaptchaBase {
  execute(opt_widget_id?: string, options?: { action: string }): Promise<string>
}

export const GO_TEMPLATES_RECAPTCHA_ACTION = 'GoTemplates'
export const SALESFORCE_RECAPTCHA_ACTION = 'SalesforceForm'

export type RecaptchaAction = typeof GO_TEMPLATES_RECAPTCHA_ACTION | typeof SALESFORCE_RECAPTCHA_ACTION

export type Execute = (action: RecaptchaAction, retries?: number) => Promise<string | undefined>

export interface ReCaptchaInstanceEnterprise {
  enterprise: ReCaptchaInstanceV3
}

export interface RecaptchaConfig {
  urls: {
    original: string
  }
  siteKey: string
}
